"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _HBMenuOld = _interopRequireDefault(require("../HBMenu/HBMenuOld"));
var _HBSplitButton = require("./HBSplitButton.styles");
var _HBButton = require("./HBButton.utils");
var _HBPopover = require("../HBPopover/HBPopover.types");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _excluded = ["splitButtonProps", "children", "size", "scope", "onClick", "buttonTheme", "margin", "disabled"],
  _excluded2 = ["isMainButtonDisabled", "isMenuButtonDisabled", "onOpenChange", "menuItems", "placement", "mainButtonTooltipProps", "onClick", "icon"],
  _excluded3 = ["content"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HBSplitButton = function HBSplitButton(_ref) {
  var splitButtonProps = _ref.splitButtonProps,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$scope = _ref.scope,
    scope = _ref$scope === void 0 ? 'system' : _ref$scope,
    onClick = _ref.onClick,
    _ref$buttonTheme = _ref.buttonTheme,
    buttonTheme = _ref$buttonTheme === void 0 ? 'primary' : _ref$buttonTheme,
    margin = _ref.margin,
    disabled = _ref.disabled,
    buttonProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _ref2 = splitButtonProps || {},
    isMainButtonDisabled = _ref2.isMainButtonDisabled,
    isMenuButtonDisabled = _ref2.isMenuButtonDisabled,
    onOpenChange = _ref2.onOpenChange,
    menuItems = _ref2.menuItems,
    placement = _ref2.placement,
    mainButtonTooltipProps = _ref2.mainButtonTooltipProps,
    onSplitButtonClick = _ref2.onClick,
    _ref2$icon = _ref2.icon,
    SplitButtonIcon = _ref2$icon === void 0 ? _HBSplitButton.SplitButtonArrowIcon : _ref2$icon,
    _splitButtonProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _ref3 = mainButtonTooltipProps || {},
    content = _ref3.content,
    _mainButtonTooltipProps = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isSplitMenuOpen = _useState2[0],
    setIsSplitMenuOpen = _useState2[1];
  var _onOpenChange = (0, _react.useCallback)(function (_ref4) {
    var isOpen = _ref4.isOpen,
      triggeredFrom = _ref4.triggeredFrom;
    if (!menuItems) {
      return;
    }
    setIsSplitMenuOpen(isOpen);
    onOpenChange === null || onOpenChange === void 0 || onOpenChange({
      isOpen: isOpen
    });
    if (triggeredFrom !== _HBPopover.HBPopoverOnOpenChangeTrigger.ClickOutside) {
      onSplitButtonClick === null || onSplitButtonClick === void 0 || onSplitButtonClick();
    }
  }, [onOpenChange, onSplitButtonClick, menuItems]);
  var mappedMenuItems = menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function (item) {
    if ('onClick' in item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        onClick: function onClick(e) {
          e.stopPropagation();
          item.onClick(e);
        }
      });
    }
    return item;
  });
  var wrappedChildren = (0, _HBButton.recursivelyWrapStringChildrenWithSpans)(children);
  var menuJSX = /*#__PURE__*/_react["default"].createElement(_HBMenuOld["default"], (0, _extends2["default"])({
    withArrow: true,
    shouldSupportOverflowHidden: true,
    stopPropagationOnTargetClick: !!menuItems,
    customStyle: {
      zIndex: 100000000
    },
    placement: placement,
    onOpenChange: _onOpenChange,
    menuItems: mappedMenuItems,
    forceClose: !menuItems,
    target: /*#__PURE__*/_react["default"].createElement(SplitButtonIcon, null)
  }, _splitButtonProps));
  var buttonTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: buttonProps.testId,
    identifier: buttonProps.testIdName || buttonProps.id,
    suffix: 'button',
    componentName: 'HBButton',
    testIdType: buttonProps.testIdType
  });
  return /*#__PURE__*/_react["default"].createElement(_HBSplitButton.SplitButton, (0, _extends2["default"])({}, buttonProps, {
    isSplitMenuOpen: isSplitMenuOpen,
    isSplitMenuTop: placement === 'top',
    onClick: isMainButtonDisabled ? undefined : onClick
    // need to solve this issue of this being a styled component
    ,
    theme: buttonTheme,
    disabled: disabled,
    isMainButtonDisabled: disabled || isMainButtonDisabled,
    isMenuButtonDisabled: disabled || isMenuButtonDisabled
    // Had to add these two due to a TS issue
    // SplitButton extends the Button styled component but it doesn't get the default values
    // assigned in HBButton
    ,
    size: size,
    scope: scope,
    $margin: margin,
    "data-testid": buttonTestId
  }), /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], (0, _extends2["default"])({}, _mainButtonTooltipProps, {
    target: /*#__PURE__*/_react["default"].createElement(_HBSplitButton.SplitTextContainer, null, wrappedChildren)
  }), content), menuItems ? menuJSX : /*#__PURE__*/_react["default"].createElement(_HBSplitButton.MenuWrapper, {
    isDisabled: disabled || isMenuButtonDisabled,
    onClick: function onClick(e) {
      e.stopPropagation();
      onSplitButtonClick === null || onSplitButtonClick === void 0 || onSplitButtonClick();
    }
  }, menuJSX));
};
var _default = exports["default"] = HBSplitButton;
//# sourceMappingURL=HBSplitButton.js.map